import React from 'react';
import { title } from '../bootstrap';
import Header from './Header';
import Nav from './Nav';
import SubNav from './SubNav';
import Hero from './Hero';
import Footer from './Footer';
import Banner from './Banner';
import { appSettings, quickLinks, appNavLeft, appNavRight } from '../store';

const Layout = ({ children }) => {
  return (
    <div>
      <Header quickLinks={quickLinks} />
      <Nav appNavLeft={appNavLeft} appNavRight={appNavRight} />
      <SubNav title={appSettings.title} />
      <Hero title={title} />
      <div>{children}</div>
      <Banner />
      <Footer />
    </div>
  );
};

export default Layout;
